import axiosRequest from '@/utils/request'

// 钱包首页
export const homePage = (params) => {
  return axiosRequest({
    url: '/wallet/home-page',
    method: 'get',
    params
  })
}

// 交易记录
export const listTradeRecord = (data) => {
  return axiosRequest({
    url: '/trade/list-trade-record',
    method: 'post',
    data
  })
}
// 获取充提转限额
export const totalityLimitAmount = () => {
  return axiosRequest({
    url: '/trade/totality-limit-amount',
    method: 'get'
  })
}
